//create interceptor
function appLoadingInterceptor($q,sharedService) {
    "ngInject";
    sharedService.loader.loadingCount = 0;

    function showLoading() {
        sharedService.loader.loadingCount++;
    }

    function showErrors(response) {
 
        if(response.data && response.data.message){
             sharedService.errorMsg = response.data.message;
        }else{
             sharedService.errorMsg = response;
        }       
        scrollTo(document.body, 0, 400); 
    }
    function hideErrors() {
        sharedService.errorMsg = null;
    }

    function hideLoading() {
        if (sharedService.loader.loadingCount > 0) {
            sharedService.loader.loadingCount--;
        }
    }

    function scrollTo(element, to, duration) {
        let start = element.scrollTop,
            change = to - start,
            increment = 20;

        let animateScroll = (elapsedTime) =>{        
            elapsedTime += increment;
            let position = easeInOut(elapsedTime, start, change, duration);                        
            element.scrollTop = position; 
            if (elapsedTime < duration) {
                setTimeout(()=> {
                    animateScroll(elapsedTime);
                }, increment);
            }
        };

        animateScroll(0);
    }

    function easeInOut(currentTime, start, change, duration) {
        currentTime /= duration / 2;
        if (currentTime < 1) {
            return change / 2 * currentTime * currentTime + start;
        }
        currentTime -= 1;
        return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
    }

    return {
        request: (config) => {
            showLoading();
            hideErrors();
            // Return the config or wrap it in a promise if blank.
            return config || $q.when(config);
        },
        response: (response) =>{
            hideLoading();
            hideErrors();
            // Return the response or wrap it in a promise if blank.            
            return response || $q.when(response);
        },
        responseError: (response) =>{
            //Show Error msg
            hideLoading();
            showErrors(response);
            // Return the promise rejection.
            return $q.reject(response);
        }
    };
}

export default appLoadingInterceptor;


// WEBPACK FOOTER //
// ./client/app/app.loadingInterceptor.js